import {ValidateEquipment} from "../MassiveActionsTypesAndFunctions";
import * as React from "react";
import {Display} from "../../../components/Display";
import {Button} from "@vebox/etui-core";
import {AppTranslations} from "../../../components/Utils/translations/AppTranslations";

declare var AppTranslations: AppTranslations;

interface EquipmentListProps {
    equipmentDetail: ValidateEquipment;
    onRemove?: (equipmentGuid: string) => void;
}

export const EquipmentListItem: React.FC<EquipmentListProps> = ({equipmentDetail, onRemove}) => {
    const texts = AppTranslations.massiveActions.massiveActionsCommon;
    const removePackage = () => onRemove(equipmentDetail.code);

    return (
        <li className={`equipment-validated ${!equipmentDetail?.valid ? 'not-found' : ''}`}>
            <div className={"icon-section"}>
                <Display isVisible={!equipmentDetail.valid}>
                    <span className="material-icons all-self-center">priority_high</span>
                </Display>
            </div>
            <div className={"equipment-section"}>
                <h2 className={"device-info text-overflow-ellipsis-hidden align-self-center bold"}>{equipmentDetail?.code}</h2>
                <Display isVisible={!equipmentDetail.valid}>
                    <h2 className={"device-info text-overflow-ellipsis-hidden align-self-center"}>{texts.equipmentNotFoundLabel}</h2>
                </Display>
            </div>
            <Button
                onClick={removePackage}
                variant={"tertiary"}
            >
                <span className="material-symbols-outlined">delete</span>
            </Button>
        </li>
    )
}